//* Libraries imports
import React from "react";

type ProductInfoProps = {
  title?: string;
  subtitle?: string;
  price?: React.ReactNode;
  imageUrl?: string;
};

export function ProductInfo({
  title = "Holding Patrimonial",
  subtitle = "Reunião de entrada",
  price = "R$ 800,00",
  imageUrl,
}: ProductInfoProps) {
  return (
    <div className="flex items-center gap-3 w-full">
      <div className="w-14 h-16 rounded-lg bg-gray-900 flex items-center justify-center overflow-hidden shrink-0">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-800" />
        )}
      </div>

      <div className="flex-1 flex flex-col gap-1 items-start">
        <h3 className="text-base font-semibold text-clarotexto-201 leading-tight">
          {title}
        </h3>
        <p className="text-sm font-normal text-clarotexto-201 leading-tight">
          {subtitle}
        </p>
        <span className="text-sm font-normal text-gray-400 leading-tight">
          {price}
        </span>
      </div>
    </div>
  );
}
